export const createVideo = {
	"title" : "Take a Virtual Tour of Europe’s Only Underwater Museum",
	"draftOnly": false,
	"logoImage" : "",
	"orientation" : "landscape",
	"themeId" : "5a15310cabc5e17e6bf29525",
	"scenes" : [
		{
			"text" : [
				"<strong>Museo Atlantico</strong> is a unique <strong>sculpture park</strong> and Europe’s only <strong>underwater museum.</strong>",
				"Located 40 feet underwater, it can only be accessed by <strong>scuba divers and snorkelers.</strong>"
			],
			"image" : "//rocketium.com/images/v2/5640531e7e119dcc577857b0/resized/1539834800594.mp4",
			"overlay": "",
			"transition": "",
			"multiplier": 1
		},
		{
			"text" : [
				"British artist <strong>Jason deCaires Taylor</strong> launched it in <strong>January 2018.</strong>"
			],
			"image" : "//rocketium.com/images/v2/561796b4ce0203f33fe8e564/resized/1531158175863.jpg",
			"overlay": "",
			"transition": "",
			"multiplier": 1
		},
		{
			"text" : [
				"Swimming around the museum is a <strong>haunting</strong> experience.",
				"The murky water and frozen figures covered in marine life feel centuries old."
			],
			"image" : "//rocketium.com/images/v2/5640531e7e119dcc577857b0/resized/1539834800660.mp4",
			"overlay": "",
			"transition": "",
			"multiplier": 1
		}
	],
	"metadata": undefined
};